import Vue from "vue";

export function getToken() {
    if (Vue.$cookies.get("token")) {
        const val = Vue.$cookies.get("token")
        return val;
    } else {
        return "";
    }
}
